import React from 'react';
import { GridItem } from '@chakra-ui/react';

export const GridItemEmpty = (props) => {
    return <GridItem bg="grayDark2" {...props} />;
};
